import styled from 'styled-components'

export const LblAmbiente = styled.span`
  font-size: 20px;
  color: red;
  font-weight: 600;
  text-align: center;
  width: 100%;
`
